import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaMapMarkerAlt, FaEnvelope, FaCode } from 'react-icons/fa';
import { siteInfo } from '../../constants/siteInfo';

const Footer: React.FC = () => {
  const { standard, special } = siteInfo.openingHours;

  const renderHours = (service: 'restaurant' | 'etangs') => {
    return standard.map(item => {
      const hours = item.services?.[service]?.[0];
      return (
        <li key={`${service}-${item.day}`} className="flex justify-between">
          <span className="w-1/2">{siteInfo.daysOfWeek[item.day]}</span>
          <span className="font-semibold w-1/2 text-right">
            {hours ? `${hours.open}h - ${hours.close}h` : 'Fermé'}
          </span>
        </li>
      );
    });
  };

  return (
    <footer className="bg-primary text-white font-body">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
          
          {/* About & Contact */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold mb-4 font-heading text-accent">Moulin Tala</h3>
              <p className="text-white/70">
                Restaurant & étangs de pêche au cœur du Morvan.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4 font-heading text-accent">Contact</h3>
              <ul className="space-y-3 text-white/80">
                 <li className="flex items-start">
                   <FaMapMarkerAlt className="mr-3 mt-1 text-accent" />
                   <span>{siteInfo.address}</span>
                 </li>
                 <li className="flex items-center">
                   <FaPhone className="mr-3 text-accent" />
                   <a href={`tel:${siteInfo.phone.replace(/\s/g, '')}`} className="hover:text-accent transition-colors">{siteInfo.phone}</a>
                 </li>
              </ul>
            </div>
          </div>

          {/* Horaires */}
          <div className="md:col-span-2 bg-black/10 p-6 rounded-lg">
            <h3 className="text-xl font-bold mb-2 font-heading text-accent text-center">Horaires d'Ouverture</h3>
            <p className="text-center text-sm text-white/70 mb-4 italic">{siteInfo.seasonText}</p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4">
              
              {/* Saison Standard */}
              <div>
                <p className="font-bold text-white/90 mb-2">Saison Standard</p>
                <div className="grid grid-cols-2 gap-x-4">
                  <div>
                    <p className="text-base font-semibold text-white/80 underline mb-1">Restaurant</p>
                    <ul className="space-y-1 text-white/70">{renderHours('restaurant')}</ul>
                  </div>
                  <div>
                    <p className="text-base font-semibold text-white/80 underline mb-1">Étangs</p>
                    <ul className="space-y-1 text-white/70">{renderHours('etangs')}</ul>
                  </div>
                </div>
              </div>

              {/* Haute Saison */}
              <div className="border-t border-white/20 lg:border-t-0 lg:border-l lg:pl-6">
                <p className="font-bold text-white/90 mb-2 pt-6 lg:pt-0">Été (14/07 - fin Août) & Jours Fériés</p>
                <p className="text-white/80 mb-2">Ouvert tous les jours :</p>
                <ul className="space-y-1 text-white/70">
                    <li>
                      <span className="font-semibold">Restaurant :</span> {`${special.restaurant[0].open}h - ${special.restaurant[0].close}h`}
                    </li>
                    <li>
                      <span className="font-semibold">Étangs :</span> {`${special.etangs[0].open}h - ${special.etangs[0].close}h`}
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/20 text-center text-sm text-white/60">
          <p>&copy; {new Date().getFullYear()} Moulin Tala. Tous droits réservés.</p>
          <p className="mt-4">
            <a 
              href="https://glowsoft.fr" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center justify-center text-accent/80 hover:text-accent transition-colors"
            >
              <FaCode className="mr-2" /> 
              <span>Créé par Glowsoft</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 